export default "__VITE_ASSET__BJzZV1vo__"